<template>
  <b-container fluid class="dproducts">
    <b-row>
      <b-col>
        <div class="loadingOverlay" v-if="isLoading"></div>
        <div class="text-left text-uppercase title p-3">
          All Products
          <span class="addBtn" v-on:click="goToAddProduct"> + Add Product</span>
        </div>
      </b-col>
    </b-row>
    <b-row class="m-2" v-if="!isLoading">
      <b-col lg="12" md="12" sm="12" xs="12" class="box text-left mb-3 pb-3" v-for="(product, index) in productList" :key="index">
        <b-row>
          <b-col lg="3" md="3" sm="12" xs="12">
            <img :src="getImage(product.attributes.image.data.attributes.url, 'url')">
          </b-col>
          <b-col lg="9" md="9" sm="12" xs="12">
            <div class="text-right">
              <div class="actionBtn" v-on:click="deleteProduct(product)">Remove</div>
              <div class="actionBtn" v-on:click="editProduct(product.id)">Edit</div>
            </div>
            <div class="clearfix"></div>
            <div>Product : {{product.attributes.name}}</div>
            <div>Description : {{product.attributes.description}}</div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="m-2" v-if="productList.length < 1">
      <b-col lg="12" md="12" sm="12" xs="12" class="box text-left mb-3 pb-3">
        No product available yet.
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'DProducts',
  data () {
    return {
      isLoading: true,
      errors: [],
      productSection: 'products',
      productList: []
    }
  },
  methods: {
    deleteProduct (product) {
      this.isLoading = true
      this.$store.dispatch('deleteProduct', {
        data: {
          id: product.id,
          token: this.$cookies.get('a').jwt
        },
        success: (res) => {
          this.deleteFile(product.attributes.image.data.id)
        },
        fail: () => {
          this.toast('Could not remove product. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    deleteFile (id) {
      this.$store.dispatch('deleteFile', {
        data: {
          id: id,
          token: this.$cookies.get('a').jwt
        },
        success: (res) => {
          this.toast('Remove product is done.', 'success', 'check')
          this.findAllProducts()
        },
        fail: () => {
          this.toast('Image delete failed.', 'error', 'error_outline')
        }
      }).then(() => {
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    editProduct (id) {
      this.$router.push({name: 'EditProduct', params: {id: id}})
    },
    findAllProducts () {
      this.isLoading = true
      this.$store.dispatch('getProductList', {
        success: (res) => {
          this.$data.productList = res.body.data
        },
        fail: () => {
          this.toast('Could not get products. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    goToAddProduct () {
      this.$router.push('/addproduct')
    },
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    currencyFormat (price) {
      return util.currencyFormat(price)
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    }
  },
  created () {
    this.findAllProducts()
  },
  computed: {
    ...mapGetters([
      'products'
    ])
  }
}
</script>

<style scoped>
.dproducts {
  min-height: 100vh;
}
.title {
  border-bottom: 1px solid #ccc;
}
.box {
  border-bottom: 1px solid #ccc;
}
.actionBtn {
  float:right;
  margin-top: 5px;
  margin-left: 15px;
  color: #455A64;
}
.actionBtn:hover {
  cursor: pointer;
  color: #000;
  text-decoration: underline;
}
.addBtn {
  background-color: #FF8F00;
  padding: 5px 25px;
  text-transform: capitalize;
  margin-left: 50px;
  color: #fff;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.addBtn:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/DProducts.vue